namespace $.$$ {
	$mol_style_define($bog_blitz_blog_page, {
		Content: {
			padding: {
				top: '8px',
				bottom: '24px',
				left: '16px',
				right: '16px',
			},
			maxWidth: '720px',
		},
		App_link: {
			align: {
				self: 'center',
			},
			font: {
				size: '18px',
				weight: 600,
			},
			margin: {
				top: '16px',
				bottom: '32px',
			},
		},
	})
}
